import React from "react";
import PropTypes from "prop-types";
import {
  Card,
  CardContent,
  CardActions,
  Typography,
  IconButton,
  Tooltip,
  Box,
  Button,
} from "@mui/material";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faInstagram,
  faTwitter,
  faFacebookF,
  faSnapchatGhost,
  faTiktok,
} from "@fortawesome/free-brands-svg-icons";
import { faGraduationCap } from "@fortawesome/free-solid-svg-icons";

const FriendInfoCard = ({ firstName, lastName, socials, school, buttons }) => {
  const socialLinks = [
    socials?.instagram && { icon: faInstagram, url: `https://instagram.com/${socials.instagram}`, label: "Instagram" },
    socials?.twitter && { icon: faTwitter, url: `https://twitter.com/${socials.twitter}`, label: "X" },
    socials?.facebook && { icon: faFacebookF, url: `https://facebook.com/${socials.facebook}`, label: "Facebook" },
    socials?.snapchat && { icon: faSnapchatGhost, url: `https://snapchat.com/add/${socials.snapchat}`, label: "Snapchat" },
    socials?.tiktok && { icon: faTiktok, url: `https://tiktok.com/@${socials.tiktok}`, label: "TikTok" },
  ].filter(Boolean);

  return (
    <Card
      sx={{
        height: "100%",
        borderRadius: 7,
        background: "rgba(255,255,255,0.05)",
        backdropFilter: "blur(10px)",
        border: "1px solid rgba(255,255,255,0.12)",
        boxShadow: "0 10px 30px rgba(0,0,0,0.25)",
      }}
    >
      <CardContent>
        <Typography fontWeight={800} align="center">
          {firstName} {lastName}
        </Typography>

        {socialLinks.length > 0 && (
          <Box sx={{ display: "flex", justifyContent: "center", gap: 1, mt: 1 }}>
            {socialLinks.map((s) => (
              <Tooltip key={s.label} title={s.label}>
                <IconButton
                  component="a"
                  href={s.url}
                  target="_blank"
                  sx={{
                    borderRadius: 12,
                    background: "rgba(0,0,0,0.3)",
                  }}
                >
                  <FontAwesomeIcon icon={s.icon} />
                </IconButton>
              </Tooltip>
            ))}
          </Box>
        )}

        {school && (
          <Box sx={{ mt: 1, textAlign: "center" }}>
            <Typography fontSize="0.85rem">
              <FontAwesomeIcon icon={faGraduationCap} /> {school.schoolName}
            </Typography>
            {school.classification && (
              <Typography fontSize="0.75rem" opacity={0.7}>
                {school.classification}
              </Typography>
            )}
          </Box>
        )}
      </CardContent>

      <CardActions sx={{ justifyContent: "center", pb: 2 }}>
        {buttons.map((b) => (
          <Button
            key={b.name}
            onClick={b.callback}
            size="small"
            variant={b.name === "Block" ? "outlined" : "contained"}
            sx={{ borderRadius: 12, textTransform: "none", fontWeight: 700 }}
          >
            {b.name}
          </Button>
        ))}
      </CardActions>
    </Card>
  );
};

FriendInfoCard.propTypes = {
  firstName: PropTypes.string.isRequired,
  lastName: PropTypes.string.isRequired,
  socials: PropTypes.object,
  school: PropTypes.object,
  buttons: PropTypes.array.isRequired,
};

export default FriendInfoCard;
